import { jsx as m } from "react/jsx-runtime";
import { useContext as n } from "react";
import s from "classnames";
import { ThemeContext as f } from "../ThemeContext/index.js";
const l = "forma-ui__grid__list", c = "forma-ui__grid__grid-6", u = "forma-ui__grid__grid-5", p = "forma-ui__grid__grid-4", b = "forma-ui__grid__grid-3", h = "forma-ui__grid__grid-2", S = "forma-ui__grid__grid-1", t = {
  list: l,
  "grid-6": "forma-ui__grid__grid-6",
  grid6: c,
  "grid-5": "forma-ui__grid__grid-5",
  grid5: u,
  "grid-4": "forma-ui__grid__grid-4",
  grid4: p,
  "grid-3": "forma-ui__grid__grid-3",
  grid3: b,
  "grid-2": "forma-ui__grid__grid-2",
  grid2: h,
  "grid-1": "forma-ui__grid__grid-1",
  grid1: S
}, x = {
  6: { desktopS: 5, tablet: 4, tabletS: 3, phone: 2 },
  5: { tablet: 4, tabletS: 3, phone: 2 },
  4: { tablet: 3, tabletS: 2, phone: 1 },
  3: { tablet: 2, tabletS: 2, phone: 1 },
  2: { phone: 1 },
  1: {}
}, k = ({ id: r, children: i, className: _, columns: g, responsive: d }) => {
  var a;
  const { viewport: o } = n(f), e = (d == null ? void 0 : d[o]) ?? ((a = x[g]) == null ? void 0 : a[o]) ?? g;
  return /* @__PURE__ */ m("div", { className: s(t.list, _, t[`grid-${e}`]), id: r, children: i });
}, w = ({ children: r, className: i, ..._ }) => /* @__PURE__ */ m("div", { className: s(t.item, i), ..._, children: r });
export {
  k as Grid,
  w as GridItem
};
